module.exports = __webpack_public_path__ + "static/cosybmonkey1-0c1c37452020d6a3f9a45f40bcb2bf72.jpeg";